import { FK, Callout, JsonField } from "../product_config/formkit";

const FIELDS = [
  {
    key: "descripcion_json",
    label: "descripcion_json",
    description: "Configuración principal del plan (calculatorConfig, restricciones, catalogo_campos, etc.)",
    rows: 14,
  },
  {
    key: "jsonarray",
    label: "json_array",
    description: "Array de configuración (módulos, opciones, items del plan)",
    rows: 8,
  },
  {
    key: "jsonmails",
    label: "jsonmails",
    description: "Configuración de correos (plantillas, destinatarios, triggers de envío)",
    rows: 8,
  },
  {
    key: "siniestros_json",
    label: "siniestros_json",
    description: "Configuración de siniestros (flujo, campos, reglas de gestión)",
    rows: 8,
  },
];

export default function JsonRawTab({ formData, handleChange }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <Callout tone="warn" title="Modo edición directa">
        Pega o edita el JSON crudo de cada campo. Los cambios se sincronizan con el guardado general del plan.
      </Callout>

      {FIELDS.map((field) => (
        <div key={field.key} style={{ border: "1px solid " + FK.border, borderRadius: 12, background: FK.surface, padding: 16 }}>
          <JsonField
            label={field.label}
            name={field.key}
            value={formData[field.key] || ""}
            onChange={handleChange}
            hint={field.description}
            rows={field.rows}
          />
        </div>
      ))}
    </div>
  );
}
